package screens.static.settings

import common.EConstants
import components.Toolbar
import components.burgerMenu.BurgerMenu
import core.extensions.isInNativeApp
import core.ionic.IonCol
import core.ionic.IonContent
import core.ionic.IonHeader
import core.ionic.IonPage
import kotlinx.browser.window
import react.FC
import react.Props

external interface SettingsScreenProps : Props

val SettingsScreen = FC<SettingsScreenProps> {
    val isInNativeApp = window.isInNativeApp()

    BurgerMenu()
    IonPage {
        id = EConstants.BURGER_MENU_CONTENT.mId

        IonHeader {
            Toolbar {
                mIsBackNavigation = true
            }
        }
        IonContent {
            IonCol {
                if (isInNativeApp) {
                    UsageAnalysis()
                }
                CookieSettings()
            }
        }
    }
}

